import { render } from "./roomEdit.vue?vue&type=template&id=112d9a52&scoped=true"
import script from "./roomEdit.vue?vue&type=script&lang=js"
export * from "./roomEdit.vue?vue&type=script&lang=js"

import "./roomEdit.vue?vue&type=style&index=0&id=112d9a52&scoped=true&lang=css"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112d9a52"]])

export default __exports__